export function createJob(id, job, isEmployee) {
    let { createJobRequest, createJobError, createJobResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'create_job',
        this.createBundle('create_job', { id, job }, this.POST, createJobRequest, createJobResult, createJobError, isEmployee)
    )
}
